import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static targets = ["carousel"]

  initialize() {
    this.updateCarousel = this.updateCarousel.bind(this)
  }

  connect() {
    const matchMedia = window.matchMedia("(min-width: 768px)")
    matchMedia.addEventListener("change", this.updateCarousel)
    if (matchMedia) this.updateCarousel({matches: matchMedia.matches})
  }

  updateCarousel(event) {
    const mdSize = event.matches
    
    this.carouselTarget.dispatchEvent(
      new CustomEvent("togglePreview", { detail: { force: mdSize } }))
    this.carouselTarget.dispatchEvent(
      new CustomEvent("toggleDots", { detail: { force: !mdSize } }))
  }
}